import { render, staticRenderFns } from "./RatePmsUpdate.vue?vue&type=template&id=40dbaa23"
import script from "./RatePmsUpdate.vue?vue&type=script&lang=js"
export * from "./RatePmsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports